import React, { Fragment, useState } from 'react';
import { reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import CloseIcon from '@material-ui/icons/Close';
import Modal from '@material-ui/core/Modal';

const AttachFileTableActions = ({ data }) => {

  const [showPdf, setShowPdf] = useState(false);

  return (<Fragment>
    <td role="cell">
      <Tooltip title="Ver">
        <IconButton aria-label="unable" style={{ padding: 2 }}>
          <SearchIcon
            onClick={() => {             
              setShowPdf(true);
            }}
          />
        </IconButton>
      </Tooltip>
      {showPdf ?
        <Modal
          open={showPdf}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          style={{ zIndex: 1000 }}
        >
          <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>
            <IconButton style={{ float: 'right' }} onClick={() => {
              setShowPdf(false);
            }}>
              <CloseIcon />
            </IconButton>

            <iframe id="pdfV" width="1000" height="700" src={process.env.REACT_APP_PUBLIC_URL + data.original.ruta + sessionStorage.getItem('token')} >
            </iframe>
          </div>
        </Modal>
        : null}
    </td>
  </Fragment>)
}

export default reduxForm({
  form: `modal-form`, // a unique identifier for this form
})(withTranslation('common')(AttachFileTableActions));